import DtoLocalization from './DtoLocalization'
import DtoAddress from './DtoAddress'

export default class {

	constructor(obj) {
		this.id = obj.id
		this.name = obj.name
		this.link = obj.link
		this.city = obj.cityId
		this.comment = obj.comment
		this.localization = new DtoLocalization(obj.dtoSiteLocalization)
		this.address = obj.address ? new DtoAddress(obj.address) : undefined
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoDetailSite.js